// extracted by mini-css-extract-plugin
module.exports = {"container":"DisasterBanner_container__1f-iK"};